<template>
  <div>
    <b-form-group :label="label">
      <validation-provider
        #default="{ errors }"
        :rules="{required: require_}"
        name="Proposta"
      >
        <multiselect
          ref="propostaMultiselect"
          v-model="value_"
          :options="propostas"
          :label="'numeroProposta'"
          placeholder=""
          track-by="id"
          class="proposta-multiselect"
          :multiple="multiple"
          :disabled="disabled"
          :close-on-select="false"
          :limit="limit"
          :limit-text="limitText"
          :select-label="''"
          :deselect-label="''"
          :selected-label="''"
          :loading="propostasLoading"
          :internal-search="false"
          @close="onTouch"
          @open="carregarPropostas"
          @search-change="carregarPropostasFiltradas"
          @input="enviarParaPai"
        >
          <template slot="noResult">
            <span>Nenhum resultado encontrado</span>
          </template>
          <template slot="noOptions">
            <span />
          </template>
          <template slot="limit">
            <strong
              v-if="value_"
              id="propostasSelecionadas"
              class="multiselect__strong"
            >{{ `+${value_.length - limit}` }}</strong>
            <b-popover
              id="propostasPopover"
              :placement="'bottom'"
              :target="'propostasSelecionadas'"
              triggers="hover"
              class="proposta-multiselect-popover"
              @show="showPopover($event)"
            >
              <div slot="title">
                <span
                  class="text-center"
                  style="vertical-align: sub"
                >Número das propostas selecionadas</span>
              </div>
              <div
                v-for="(proposta, i) in value_"
                :key="i"
              >
                <b-row>
                  <b-col cols="12">
                    <!--<span>{{ `${proposta.numeroProposta}` }}</span>-->
                    <span>{{ `${proposta.numeroProposta}` }}</span>
                    <hr style="border-top: 1px solid #a3a4a66b !important; margin: 0.5rem 0">
                  </b-col>
                </b-row>
              </div>
            </b-popover>
          </template>
        </multiselect>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </div>
</template>

<style lang="scss">
.proposta-multiselect {
  background: none;
  border-radius: 0.357rem;

  & .multiselect__content {
    display: block !important;
  }

  & .multiselect__element {
    font-size: 0.9rem;
  }

  & .multiselect__strong {
    right: 26px !important;
  }

  & .multiselect__tags {
    padding-right: 0px !important;
    max-height: auto !important;
  }

  & .multiselect__tag {
    white-space: nowrap !important;
    overflow: hidden !important;
    max-width: calc(23em - 25px);
    text-overflow: ellipsis !important;
    background: var(--primary) !important;
    border-radius: 3px !important;
    span {
      font-size: 0.9rem;
    }
  }

  & .multiselect__option {
    & svg {
      display: none;
    }
  }

  & .multiselect__option--selected {
    background: var(--primary) !important;
    color: #ffffff !important;
    font-weight: normal;
    & .company-identification span {
      color: #ffffff !important;
      background-color: transparent;
      border: 1px solid #ffffff !important;
    }
    & svg {
      display: inline;
    }
  }

  & .multiselect__option--highlight {
    background: rgba(var(--primary-rgb), 0.1);
    color: var(--primary);
  }

  & .multiselect__strong {
    color: var(--primary);
    cursor: pointer;
  }

  & .multiselect__tag-icon::after {
    color: #a6eda06e;
    font-size: 1.7rem;
  }

  & .multiselect__tag-icon:hover {
    background: none;
  }
}

.proposta-multiselect-popover .popover-body {
  height: 360px;
  overflow-y: auto;
  overflow-x: hidden;
  white-space: pre-wrap;
}
</style>

<script>
/* eslint-disable no-underscore-dangle */
import {
  required,
} from '@validations'
import { ValidationProvider } from 'vee-validate'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'

export default {
  name: 'PropostaMultiselect',
  components: {
    Multiselect,
    ValidationProvider,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    require: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [Object, Array],
      default: () => {},
    },
    filtroAdicional: {
      type: Function,
      default: () => null,
    },
    label: {
      type: String,
      default: 'Número da proposta',
    },
    externo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
      valueAttr: null,
      foiAcessado: false,
      propostas: [],
      primeroAcesso: true,
      filtros: [
        {
          colunas: ['numeroProposta'],
          valor: null,
        },
      ],
      propostasCarregadas: [],
      limit: 3,
      propostasLoading: false,
    }
  },
  computed: {
    value_: {
      get() {
        return this.valueAttr ? this.valueAttr : this.value
      },
      set(value) {
        this.valueAttr = value
      },
    },
    isInvalid() {
      return this.invalid && this.foiAcessado
    },
    require_: {
      get() {
        return this.require
      },
    },
  },
  watch: {
    value(val, oldVal) {
      if (val !== oldVal) {
        this.value_ = val
      }
    },
  },
  mounted() {
    if (this.$refs.propostaMultiselect) {
      const element = this.$refs.propostaMultiselect.$el.offsetWidth
      this.limit = Math.trunc(element / 180)
    }
  },
  methods: {
    showPopover(e) {
      const el = document.getElementsByClassName('multiselect proposta-multiselect multiselect--active')
      if (el.length === 1) {
        e.preventDefault()
      }
    },
    limitText(count) {
      return `+${count}`
    },
    carregarPropostas() {
      const el = document.getElementById('propostasPopover')
      if (el) {
        this.$refs.propostaMultiselect.isOpen = false
      } else if (!el) {
        if (this.primeroAcesso) {
          this.propostasLoading = true
          api.getPropostasResumidas(this.filtros, this.externo)
            .then(payload => {
              this.propostasCarregadas = payload.data
              this.setItensCarregados(payload.data)
              this.primeroAcesso = false
              this.propostasLoading = false
              this.$refs.propostaMultiselect.isOpen = true
            })
            .catch(err => {
              this.propostasLoading = false
              this.$errorFormated(err.response)
              throw err
            })
        } else {
          this.propostas = [...this.propostasCarregadas]
          this.setItensCarregados(this.propostas)
          this.$refs.propostaMultiselect.isOpen = true
        }
      }
    },
    carregarPropostasFiltradas(value) {
      if (value.length > 5) {
        this.filtros[0].valor = value
        this.propostasLoading = true
        api.getPropostasResumidas(this.filtros, this.externo)
          .then(payload => {
            this.setItensCarregados(payload.data)
            this.propostasLoading = false
          })
          .catch(err => {
            this.propostasLoading = false
            this.$errorFormated(err.response)
            throw err
          })
      }
    },
    setItensCarregados(itensCarregados) {
      const itensFiltroAdicional = this.filtroAdicional(itensCarregados)
      this.propostas = itensFiltroAdicional !== null ? itensFiltroAdicional : itensCarregados
    },
    enviarParaPai() {
      this.$emit('select', !this.value_ ? null : this.value_)
      this.$emit('input', !this.value_ ? null : this.value_)
    },
    onTouch() {
      this.foiAcessado = true
    },
  },
}
</script>
